/**
 * AR-2735 when page is translated via Google translate, the links need to remain relative to the subdomain of
 * translate.goog
 * @param string url
 * @return string
 */
function getAtlasRelativeLink (url) {
  if (!location.host.includes('.translate.goog')) {
    return url
  }
  const query = new URLSearchParams(location.search).toString()
  return `${location.origin}${url}${url.includes('?') ? '&' : '?'}${query}`
}
export default { getAtlasRelativeLink }
